import type { ReactNode } from 'react'
import invariant from 'tiny-invariant'
import { cn } from '../lib/utils'
import { Skeleton } from './ui/skeleton'
import { useForceLoading } from '../lib/skeletonDebug'

export function SectionHeader({
  loading: loadingProp,
  children,
  action,
  variant = 'default',
  className,
}: {
  loading?: boolean
  children?: ReactNode
  action?: ReactNode
  /** `default` = list-page heading row; `settings` = smaller standalone label above a settings/profile card. */
  variant?: 'default' | 'settings'
  className?: string
}) {
  const loading = useForceLoading(loadingProp)
  if (loading) {
    if (variant === 'settings') {
      return <Skeleton className="h-3 w-20 mb-3" />
    }
    return (
      <div className="flex items-center justify-between h-9">
        <Skeleton className="h-4 w-20" />
      </div>
    )
  }

  invariant(children !== undefined, 'SectionHeader: children is required when not loading')

  if (variant === 'settings') {
    return (
      <h2 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3">
        {children}
      </h2>
    )
  }

  return (
    <div className={cn('flex items-center justify-between h-9', className)}>
      <h2 className="text-sm md:text-base font-medium text-muted-foreground uppercase tracking-wider">
        {children}
      </h2>
      {action}
    </div>
  )
}
